import { Outlet } from "react-router-dom";
import PreferredLanguageProvider from "src/context/PreferredLanguageProvider";

const PreferredLanguageLayout = () => {
  return (
    // This is a very basic version of the layout with time, we can update it and add more if necessary.
    <PreferredLanguageProvider>
      <Outlet />
    </PreferredLanguageProvider>
  );
};

export default PreferredLanguageLayout;
